import React from "react";
import styled from "styled-components";

import Footer from "src/components/Footer";
import { colors } from "src/styles";
import { Locations } from "./Locations";
import { getUserData } from "src/redux/selectors/user";
import { useSelector } from "react-redux";

export const TimeAndAttendanceLogs: React.FC = () => {
  const { clientId } = useSelector(getUserData);

  return (
    <Container>
      <Locations clientId={clientId} />
      <StickyFooter />
    </Container>
  );
};

const Container = styled.div`
  background-color: ${colors.white.default};
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 60px;
`;

const StickyFooter = styled(Footer)`
  position: sticky;
  margin-top: auto;
`;
